<template>
  <footer class="text-muted m-3">
    <div class="container">
      <div class="sns justify-content-center d-flex">
        <a href="https://www.facebook.com/ohisamakitchenehonya/" target="_blank">
          <img src="/static/images/header/sns_f.png" alt="facebook アイコン画像" class="img-fluid">
        </a>
        <a href="https://www.instagram.com/ohisamakitchen/?hl=ja" target="_blank">
          <img src="/static/images/header/sns_i.png" alt="instagram アイコン画像" class="img-fluid">
        </a>
        <a href="https://twitter.com/ohisamapandakun" target="_blank">
          <img src="/static/images/header/sns_t.png" alt="twitter アイコン画像" class="img-fluid">
        </a>
        <a href="https://www.youtube.com/channel/UCs8jILWqrBQyuyrmwjUUTiA" target="_blank">
          <img src="/static/images/header/sns_y.png" alt="youtube アイコン画像" class="img-fluid">
        </a>
      </div>
      <ul class="nav justify-content-center">
        <li class="nav-item">
          <a class="nav-link active" href="mailto:koarakun@ohisamak-ehonya.com">お問い合わせ</a>
        </li>
        <li class="nav-item">
          <router-link to="/privacypolicy.html" class="nav-link">プライバシーポリシー</router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">© ayrcreative ltd, all rights reserved.</a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
  export default {
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue